import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { GetConfirmedQc, Status } from '../../services/apiTypes';
import {
  ConfirmedQcParam,
  fetchConfirmedQc as fetchConfirmedQcAPI,
} from './api';
import { isGetConfirmedQc } from '../../_utils/typeGuardUtils';

interface ConfirmedQcState {
  status: Status;
  confirmedQc?: GetConfirmedQc;
}

const initialState: ConfirmedQcState = {
  status: 'idle',
};

export const fetchConfirmedQc = createAsyncThunk(
  'confirmedQc/fetchConfirmedQc',
  async (params: ConfirmedQcParam, { rejectWithValue }) => {
    try {
      return await fetchConfirmedQcAPI(params);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const confirmedQcSlice = createSlice({
  name: 'confirmedQc',
  initialState,
  reducers: {
    resetConfirmedQc: (state) => {
      state.confirmedQc = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchConfirmedQc.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchConfirmedQc.fulfilled, (state, action) => {
        state.status = 'succeeded';
        if (isGetConfirmedQc(action.payload)) {
          state.confirmedQc = action.payload;
        }
      })
      .addCase(fetchConfirmedQc.rejected, (state) => {
        state.status = 'failed';
      });
  },
});

export const { resetConfirmedQc } = confirmedQcSlice.actions;

export default confirmedQcSlice.reducer;
